import React from "react";

const Underline = ({ customComponent, onChange, isActive, isDisabled }) => {
	const toggleBold = () => {
		if (onChange) onChange();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleBold}
				title="Underline"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-underline" />}
			</button>
		</>
	);
};

export default Underline;
